import template from './exact-address.jade';
import { ExactAddress } from './exact-address.controller';
import './exact-address.css';

export default angular.module('cian.addForm.exactAddress', []).directive('cianAfAddressExactAddress', () => ({
  scope: {},
  bindToController: {},
  controller: ExactAddress,
  controllerAs: 'exactAddressCtrl',
  template,
})).name;
